// extracted by css-extract-rspack-plugin
export default {"wrapper":"bNdQM"};